
import { WorldCountry } from '../types';

export const thailandExpanded: WorldCountry = {
  code: 'TH',
  name: 'Thailand',
  slug: 'thailand',
  population: 69950000,
  topCities: [
    // Major cities
    { name: 'Bangkok', slug: 'bangkok', population: 8305218 },
    { name: 'Chiang Mai', slug: 'chiang-mai', population: 127240 },
    { name: 'Phuket', slug: 'phuket', population: 79308 },
    { name: 'Pattaya', slug: 'pattaya', population: 119532 },
    { name: 'Hat Yai', slug: 'hat-yai', population: 157678 },
    { name: 'Udon Thani', slug: 'udon-thani', population: 142670 },
    { name: 'Nakhon Ratchasima', slug: 'nakhon-ratchasima', population: 174332 },
    { name: 'Khon Kaen', slug: 'khon-kaen', population: 147579 },
    { name: 'Rayong', slug: 'rayong', population: 61063 },
    { name: 'Chonburi', slug: 'chonburi', population: 219164 },
    
    // Extended cities to reach 100
    { name: 'Nonthaburi', slug: 'nonthaburi', population: 264201 },
    { name: 'Pak Kret', slug: 'pak-kret', population: 194944 },
    { name: 'Chiang Rai', slug: 'chiang-rai', population: 69899 },
    { name: 'Lamphun', slug: 'lamphun', population: 17456 },
    { name: 'Lampang', slug: 'lampang', population: 59099 },
    { name: 'Mae Hong Son', slug: 'mae-hong-son', population: 6613 },
    { name: 'Nan', slug: 'nan', population: 24581 },
    { name: 'Phayao', slug: 'phayao', population: 19118 },
    { name: 'Phrae', slug: 'phrae', population: 17971 },
    { name: 'Uttaradit', slug: 'uttaradit', population: 24285 },
    { name: 'Sukhothai', slug: 'sukhothai', population: 37000 },
    { name: 'Tak', slug: 'tak', population: 24157 },
    { name: 'Kamphaeng Phet', slug: 'kamphaeng-phet', population: 30114 },
    { name: 'Phichit', slug: 'phichit', population: 23066 },
    { name: 'Phitsanulok', slug: 'phitsanulok', population: 85757 },
    { name: 'Uthai Thani', slug: 'uthai-thani', population: 15617 },
    { name: 'Nakhon Sawan', slug: 'nakhon-sawan', population: 93141 },
    { name: 'Chainat', slug: 'chainat', population: 17465 },
    { name: 'Sing Buri', slug: 'sing-buri', population: 12534 },
    { name: 'Ang Thong', slug: 'ang-thong', population: 13738 },
    { name: 'Lopburi', slug: 'lopburi', population: 26500 },
    { name: 'Saraburi', slug: 'saraburi', population: 37598 },
    { name: 'Ayutthaya', slug: 'ayutthaya', population: 54415 },
    { name: 'Pathum Thani', slug: 'pathum-thani', population: 123564 },
    { name: 'Nakhon Nayok', slug: 'nakhon-nayok', population: 25089 },
    { name: 'Prachinburi', slug: 'prachinburi', population: 25892 },
    { name: 'Sa Kaeo', slug: 'sa-kaeo', population: 17090 },
    { name: 'Chachoengsao', slug: 'chachoengsao', population: 52538 },
    { name: 'Chanthaburi', slug: 'chanthaburi', population: 27602 },
    { name: 'Trat', slug: 'trat', population: 18123 },
    { name: 'Samut Prakan', slug: 'samut-prakan', population: 388920 },
    { name: 'Samut Songkhram', slug: 'samut-songkhram', population: 35278 },
    { name: 'Samut Sakhon', slug: 'samut-sakhon', population: 210537 },
    { name: 'Nakhon Pathom', slug: 'nakhon-pathom', population: 127669 },
    { name: 'Ratchaburi', slug: 'ratchaburi', population: 46397 },
    { name: 'Kanchanaburi', slug: 'kanchanaburi', population: 52707 },
    { name: 'Suphan Buri', slug: 'suphan-buri', population: 26656 },
    { name: 'Nong Khai', slug: 'nong-khai', population: 58345 },
    { name: 'Loei', slug: 'loei', population: 20838 },
    { name: 'Sakon Nakhon', slug: 'sakon-nakhon', population: 76237 },
    { name: 'Nakhon Phanom', slug: 'nakhon-phanom', population: 26763 },
    { name: 'Mukdahan', slug: 'mukdahan', population: 37910 },
    { name: 'Yasothon', slug: 'yasothon', population: 21134 },
    { name: 'Amnat Charoen', slug: 'amnat-charoen', population: 13598 },
    { name: 'Ubon Ratchathani', slug: 'ubon-ratchathani', population: 120362 },
    { name: 'Sisaket', slug: 'sisaket', population: 61931 },
    { name: 'Surin', slug: 'surin', population: 43882 },
    { name: 'Buriram', slug: 'buriram', population: 66699 },
    { name: 'Maha Sarakham', slug: 'maha-sarakham', population: 55550 },
    { name: 'Roi Et', slug: 'roi-et', population: 44261 },
    { name: 'Kalasin', slug: 'kalasin', population: 37653 },
    { name: 'Chaiyaphum', slug: 'chaiyaphum', population: 58350 },
    { name: 'Phetchabun', slug: 'phetchabun', population: 23704 },
    { name: 'Nong Bua Lamphu', slug: 'nong-bua-lamphu', population: 12247 },
    { name: 'Prachuap Khiri Khan', slug: 'prachuap-khiri-khan', population: 19660 },
    { name: 'Phetchaburi', slug: 'phetchaburi', population: 45312 },
    { name: 'Hua Hin', slug: 'hua-hin', population: 84883 },
    { name: 'Cha-am', slug: 'cha-am', population: 70542 },
    { name: 'Chumphon', slug: 'chumphon', population: 33522 },
    { name: 'Ranong', slug: 'ranong', population: 16163 },
    { name: 'Surat Thani', slug: 'surat-thani', population: 127201 },
    { name: 'Krabi', slug: 'krabi', population: 52867 },
    { name: 'Phang Nga', slug: 'phang-nga', population: 9939 },
    { name: 'Nakhon Si Thammarat', slug: 'nakhon-si-thammarat', population: 106463 },
    { name: 'Phatthalung', slug: 'phatthalung', population: 42986 },
    { name: 'Songkhla', slug: 'songkhla', population: 75048 },
    { name: 'Satun', slug: 'satun', population: 21498 },
    { name: 'Trang', slug: 'trang', population: 59637 },
    { name: 'Pattani', slug: 'pattani', population: 44353 },
    { name: 'Yala', slug: 'yala', population: 77285 },
    { name: 'Narathiwat', slug: 'narathiwat', population: 40521 },
    { name: 'Koh Samui', slug: 'koh-samui', population: 62658 },
    { name: 'Koh Phangan', slug: 'koh-phangan', population: 12352 },
    { name: 'Koh Tao', slug: 'koh-tao', population: 2321 },
    { name: 'Ao Nang', slug: 'ao-nang', population: 7800 },
    { name: 'Phi Phi Islands', slug: 'phi-phi-islands', population: 2500 },
    { name: 'Koh Lanta', slug: 'koh-lanta', population: 25225 },
    { name: 'Khao Lak', slug: 'khao-lak', population: 5000 },
    { name: 'Similan Islands', slug: 'similan-islands', population: 200 },
    { name: 'Koh Chang', slug: 'koh-chang', population: 5356 },
    { name: 'Koh Kood', slug: 'koh-kood', population: 2042 },
    { name: 'Koh Mak', slug: 'koh-mak', population: 371 },
    { name: 'Koh Samet', slug: 'koh-samet', population: 1084 },
    { name: 'Jomtien', slug: 'jomtien', population: 35000 },
    { name: 'Bang Saen', slug: 'bang-saen', population: 15000 },
    { name: 'Si Racha', slug: 'si-racha', population: 19221 },
    { name: 'Laem Chabang', slug: 'laem-chabang', population: 79245 },
    { name: 'Map Ta Phut', slug: 'map-ta-phut', population: 12000 },
    { name: 'U-Tapao', slug: 'u-tapao', population: 8500 }
  ]
};
